import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  TeacherLayer  from '../components/teacher/TeacherLayer'

export const TeacherPage = () => {
  return (
    <MasterLayout>
        <TeacherLayer   />
    </MasterLayout>

  )
}
